<div class="modal fade" id="changeCustomer" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header p-3">
        <h5 class="modal-title" id="modal_title">{{ 'BookingSettings.CreateNew.Title' | translate }} {{ ( 'Standard.Customer' | translate ) | lowercase }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="startAnew()">
          <i class="fa fa-window-close red" aria-hidden="true"></i>
        </button>
      </div>
      <div class="modal-body p-3" *ngIf="form.customer">
        <!--Search for Customer-->
        <div class="row mb-3" *ngIf="!settings.show.manualMode">
          <div class="col-12">
            <app-customer-search id="clientSelect" (client)="customerSearchToForm($event)" [options]="{offset:-15.4, maxHeight:65}"></app-customer-search>
          </div>
        </div>
        <div class="row mb-3 ml-0" *ngIf="!settings.show.manualMode && form.customer.customerName != ''">
          <div class="col-3 address">
            <h3>{{ 'Standard.CustomerAddress' | translate }}</h3>
            <div><b>{{form.customer.customerName}}</b></div>
            <div>{{form.customer.customerAddress}}</div>
            <div> {{form.customer.customerZipCode}} {{form.customer.customerCity}}</div>
          </div>
          <div class="col-1"></div>
          <div class="col-3 address">
            <h3>{{ 'Standard.InvoiceAddress' | translate }}</h3>
            <div><b>{{form.invoice.invoiceName}}</b></div>
            <div>{{form.invoice.invoiceAddress}}</div>
            <div> {{form.invoice.invoiceZipCode }} {{form.invoice.invoiceCity}}</div>
          </div>
          <div class="col-1"></div>
          <div class="col-3 address">
            <h3>{{ 'Standard.DeliveryAddress' | translate }}</h3>
            <div><b>{{form.delivery.name}}</b></div>
            <div>{{form.delivery.address}}</div>
            <div>{{form.delivery.zipCode}} {{form.delivery.city}}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center">
            <button class="btn btn-success mb-3 mr-3" (click)="settings.show.alternateAddresses = true; settings.show.manualDelivery = false" *ngIf="chosenCustomer && chosenCustomer.addresses.length > 0">{{ 'Buttons.ChangeDeliveryAddress' | translate }}</button>
            <button class="btn btn-info mb-3 " (click)="clearDeliveryAddress();createManualDelivery(); settings.show.alternateAddresses = false; settings.type.deliveryIsManual = true" *ngIf="chosenCustomer">{{ 'Buttons.CreateNew' | translate }} {{ ('Standard.DeliveryAddress' | translate) | lowercase }}</button>
          </div>
        </div>
        <div class="row mb-3" *ngIf="settings.show.alternateAddresses">
          <div class="col-12 altAddress customScroll">
            <table class="table table-striped table-sm" aria-label="Delivery addresses">
              <tr>
                <th>{{ 'Standard.Name' | translate }}</th>
                <th>{{ 'Standard.Address' | translate }}</th>
                <th>{{ 'Standard.Zipcode' | translate }}</th>
                <th>{{ 'Standard.City' | translate }}</th>
              </tr>
              <tr *ngFor="let x of chosenCustomer.addresses" (click)="changeDeliveryAddress(x); settings.type.deliveryIsManual = false">
                <td>{{x.customerName}}</td>
                <td>{{x.customerAddress}}</td>
                <td>{{x.customerZipCode}}</td>
                <td>{{x.customerCity}}</td>
              </tr>
            </table>
          </div>
        </div>

        <div class="row mb-3" *ngIf="settings.show.manualMode">
          <ul class="nav nav-tabs" id="nav-tab" role="tablist">
            <li class="nav-item">
              <a class="nav-link" [ngClass]="settings.show.manualCustomer ? 'active' : ''" id="customerInfo-tab" data-toggle="tab" href="#customerInfo" role="tab" (click)="settings.show.manualCustomer = true"><b>{{ 'Standard.CustomerAddress' | translate }}</b></a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [ngClass]="settings.show.manualInvoice ? 'active' : ''" id="invoiceInfo-tab" data-toggle="tab" href="#invoiceInfo" role="tab" (click)="settings.show.manualInvoice = true"><b>{{ 'Standard.InvoiceAddress' | translate }}</b></a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [ngClass]="settings.show.manualDelivery ? 'active' : ''" id="deliveryInfo-tab" data-toggle="tab" href="#deliveryInfo" role="tab" (click)="settings.show.manualDelivery = true"><b>{{ 'Standard.DeliveryAddress' | translate }}</b></a>
            </li>
          </ul>
        </div>

        <!--CREATE NEW CUSTOMER-->
        <!--MANUAL CUSTOMER ADDRESS-->
        <div class="manualCustomerAddress row" *ngIf="settings.show.manualCustomer && settings.show.manualMode">
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <label class="mb-0" for="CustomerName">{{ 'Standard.Name' | translate }} *</label>
                <input class="form-control" type="text" [(ngModel)]="form.customer.customerName" id="CustomerName" autocomplete="dont_do_anything">
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-4">
                <label class="mb-0" for="CustomerZipCode">{{ 'Standard.Zipcode' | translate }} *</label>
                <input class="form-control" type="text" [(ngModel)]="form.customer.customerZipCode" id="CustomerZipCode" (keyup)="cityLookup()" autocomplete="dont_do_anything">
              </div>
              <div class="col-8">
                <label class="mb-0" for="CustomerCity">{{ 'Standard.City' | translate }} *</label>
                <input class="form-control" type="text" [(ngModel)]="form.customer.customerCity" id="CustomerZipCode" autocomplete="dont_do_anything">
              </div>
            </div>
            <div class="row mb-2">
              <div class="col">
                <label class="mb-0" for="CustomerAddress">{{ 'Standard.Address' | translate }} *</label>
                <input class="form-control" type="text" [(ngModel)]="form.customer.customerAddress" id="CustomerAddress" (keyup)="addressLookup()" list="addressList" autocomplete="dont_do_anything">
                <datalist id="addressList">
                  <option *ngFor="let address of addresses" value="{{ address }}"></option>
                </datalist>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">
                <label class="mb-0" for="CustomerEmail">{{ 'Standard.Email' | translate }} *</label>
                <input class="form-control" type="email" [(ngModel)]="form.customer.customerEmail" id="CustomerEmail" autocomplete="dont_do_anything">
              </div>
              <div class="col-2">
                <label for="manualCustomerCountryCode">{{ 'Standard.CountryCode' | translate}}</label>
                <select [(ngModel)]="manualInputCustomerCountryCode" class="form-control" id="manualCustomerCountryCode">
                  <option value="+34">34</option>
                  <option value="+44">44</option>
                  <option value="+45">45</option>
                  <option value="+46">46</option>
                  <option value="+47">47</option>
                  <option value="+49">49</option>
                  <option value="+298">298</option>
                </select>
              </div>
              <div class="col-5">
                <label class="mb-0" for="CustomerPhone">{{ 'Standard.Phone' | translate }} *</label>
                <input class="form-control" type="number" [(ngModel)]="form.customer.customerMobile" id="CustomerPhone" autocomplete="dont_do_anything">
              </div>
            </div>
          </div>
          <div class="col-12 mt-3 text-center">
            <button class="btn btn-success mr-3" (click)="copyFrom('invoice','customer')" [disabled]="!validateInvoice()">{{ 'Word.Copy' | translate }} {{ ('Standard.InvoiceAddress' | translate) | lowercase }}</button>
            <button class="btn btn-success" (click)="copyFrom('delivery','customer')" [disabled]="!validateDelivery()">{{ 'Word.Copy' | translate }} {{ ('Standard.DeliveryAddress' | translate) | lowercase }}</button>
          </div>
        </div>
        <!--MANUAL INVOICE ADDRESS-->
        <div class="manualInvoiceAddress row" *ngIf="settings.show.manualInvoice && settings.show.manualMode">
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <label class="mb-0" for="InvoiceName">{{ 'Standard.Name' | translate }} *</label>
                <input class="form-control" type="text" [(ngModel)]="form.invoice.invoiceName" id="InvoiceName" autocomplete="dont_do_anything">
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-4">
                <label class="mb-0" for="InvoiceZipCode">{{ 'Standard.Zipcode' | translate }} *</label>
                <input class="form-control" type="text" [(ngModel)]="form.invoice.invoiceZipCode" id="InvoiceZipCode" (keyup)="cityLookup()" autocomplete="dont_do_anything">
              </div>
              <div class="col-8">
                <label class="mb-0" for="InvoiceCity">{{ 'Standard.City' | translate }} *</label>
                <input class="form-control" type="text" [(ngModel)]="form.invoice.invoiceCity" id="InvoiceCity" autocomplete="dont_do_anything">
              </div>
            </div>
            <div class="row mb-2">
              <div class="col">
                <label class="mb-0" for="InvoiceAddress">{{ 'Standard.Address' | translate }} *</label>
                <input class="form-control" type="text" [(ngModel)]="form.invoice.invoiceAddress" id="InvoiceAddress" (keyup)="addressLookup()" list="addressList" autocomplete="dont_do_anything">
                <datalist id="addressList">
                  <option *ngFor="let address of addresses" value="{{ address }}"></option>
                </datalist>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">
                <label class="mb-0" for="InvoiceEmail">{{ 'Standard.Email' | translate }} *</label>
                <input class="form-control" type="email" [(ngModel)]="form.invoice.invoiceEmail" id="InvoiceEmail" autocomplete="dont_do_anything">
              </div>
              <div class="col-2">
                <label for="manualInvoiceCountryCode">{{ 'Standard.CountryCode' | translate}}</label>
                <select [(ngModel)]="manualInputInvoiceCountryCode" class="form-control" id="manualInvoiceyCountryCode">
                  <option value="+34">34</option>
                  <option value="+44">44</option>
                  <option value="+45">45</option>
                  <option value="+46">46</option>
                  <option value="+47">47</option>
                  <option value="+49">49</option>
                  <option value="+298">298</option>
                </select>
              </div>
              <div class="col-5">
                <label class="mb-0" for="InvoicePhone">{{ 'Standard.Phone' | translate }} *</label>
                <input class="form-control" type="number" [(ngModel)]="form.invoice.invoiceMobile" id="InvoicePhone" autocomplete="dont_do_anything">
              </div>
            </div>
          </div>
          <div class="col-12 mt-3 text-center">
            <button class="btn btn-success mr-3" (click)="copyFrom('customer','invoice')" [disabled]="!validateCustomer()">{{ 'Word.Copy' | translate }} {{ ('Standard.CustomerAddress' | translate) | lowercase }}</button>
            <button class="btn btn-success" (click)="copyFrom('delivery','invoice')" [disabled]="!validateDelivery()">{{ 'Word.Copy' | translate }} {{ ('Standard.DeliveryAddress' | translate) | lowercase }}</button>
          </div>
        </div>
        <!--MANUAL DELIVERY ADDRESS-->
        <div class="manualDeliveryAddress row" *ngIf="settings.show.manualDelivery">
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <label class="mb-0" for="CustomerName">{{ 'Standard.Name' | translate }} *</label>
                <input class="form-control" type="text" [(ngModel)]="form.delivery.name" id="DeliveryName" autocomplete="dont_do_anything">
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-4">
                <label class="mb-0" for="CustomerZipCode">{{ 'Standard.Zipcode' | translate }} *</label>
                <input class="form-control" type="text" [(ngModel)]="form.delivery.zipCode" id="DeliveryZipCode" (keyup)="cityLookup()" autocomplete="dont_do_anything">
              </div>
              <div class="col-8">
                <label class="mb-0" for="CustomerCity">{{ 'Standard.City' | translate }} *</label>
                <input class="form-control" type="text" [(ngModel)]="form.delivery.city" id="DeliveryCity" autocomplete="dont_do_anything">
              </div>
            </div>
            <div class="row mb-2">
              <div class="col">
                <label class="mb-0" for="CustomerAddress">{{ 'Standard.Address' | translate }} *</label>
                <input class="form-control" type="text" [(ngModel)]="form.delivery.address" id="DeliveryAddress" (keyup)="addressLookup()" list="addressList" autocomplete="dont_do_anything">
                <datalist id="addressList">
                  <option *ngFor="let address of addresses" value="{{ address }}"></option>
                </datalist>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-5">
                <label class="mb-0" for="CustomerEmail">{{ 'Standard.Email' | translate }} *</label>
                <input class="form-control" type="email" [(ngModel)]="form.delivery.email" id="DeliveryEmail" autocomplete="dont_do_anything">
              </div>
              <div class="col-2">
                <label for="manualDeliveryCountryCode">{{ 'Standard.CountryCode' | translate}}</label>
                <select [(ngModel)]="manualInputDeliveryCountryCode" class="form-control" id="manualDeliveryCountryCode">
                  <option value="+34">34</option>
                  <option value="+44">44</option>
                  <option value="+45">45</option>
                  <option value="+46">46</option>
                  <option value="+47">47</option>
                  <option value="+49">49</option>
                  <option value="+298">298</option>
                </select>
              </div>
              <div class="col-5">
                <label class="mb-0" for="CustomerPhone">{{ 'Standard.Phone' | translate }} *</label>
                <input class="form-control" type="number" [(ngModel)]="form.delivery.mobile" id="DeliveryPhone" autocomplete="dont_do_anything">
              </div>
            </div>
          </div>
          <div class="col-12 mt-3 text-center" *ngIf="settings.show.manualMode">
            <button class="btn btn-success mr-3" (click)="copyFrom('customer','delivery')" [disabled]="!validateCustomer()">{{ 'Word.Copy' | translate }} {{ ('Standard.CustomerAddress' | translate) | lowercase }}</button>
            <button class="btn btn-success" (click)="copyFrom('invoice','delivery')" [disabled]="!validateInvoice()">{{ 'Word.Copy' | translate }} {{ ('Standard.InvoiceAddress' | translate) | lowercase }}</button>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" (click)="newCustomer()" *ngIf="!settings.show.manualMode">{{ 'Buttons.CreateNew' | translate }} {{ ('Standard.Customer' | translate ) | lowercase }}</button>
        <button class="btn btn-danger" (click)="startAnew()" *ngIf="form.customer.customerName != ''">{{ 'Buttons.Clear' | translate }}</button>
        <button class="btn btn-danger" (click)="startAnew()" *ngIf="form.customer.customerName == '' && settings.show.manualMode">{{ 'Buttons.Back' | translate }}</button>
        <button class="btn btn-success" (click)="changeCustomer()" [disabled]="!validateInvoice()" data-dismiss="modal">{{ 'Word.Update' | translate }}</button>
      </div>
    </div>
  </div>
</div>
